import React from 'react';
import './hero_section.css';
function HeroSection() {
  return (
    <section>
      <div id="hero-section-container">
        <div id="hero-section-content">
          <div id="hero-text">
            <div id="text-section-title">
              <p id="hero-section-title">IYNS Research Foundation</p>
            </div>
            <div id="text-section-text">
              <p id="text-section-content">
                IYNS Research Foundation, popularly known as Indian Youth Nuclear Society.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
